import { render } from "./BlogSidebarZircBridges.vue?vue&type=template&id=0200a4e6"
import script from "./BlogSidebarZircBridges.vue?vue&type=script&lang=js"
export * from "./BlogSidebarZircBridges.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__